import { goodsRequest } from '@/utils/request'

// 获取大店商家coId列表
export function getBigShopCoIdList() {
    return goodsRequest.get('/freshman/config/getCoIdList')
}
